<template>
    <div class="Nav">
        <router-link to='/English'><img src="img/logo2.jpg"></router-link>
        <div class="Navigation-cut">
            <div class="Navigation-mane">
                <p><router-link to="/pc">中文</router-link></p>
                <p class="Navigation-mane-click">English</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'NavEnglish',
    data() {
        return {
            changeIndex:-1
        }
    },
}
</script>

<style scoped>
    a:hover {
            text-decoration: none;
    }
    .Nav{
        width: 100%;
        height: 100px;
        display: flex;
        display: -webkit-flex;
        align-items:center;
        justify-content: space-between;
    } 
    .Navigation-fence {
        float: right;
        position: relative;
    }

    .Navigation-fence-oen {
        float: left;
        width: 700px;
    }

    .Navigation-fence-oen li {
        float: left;
        line-height: 104px;
        width: 14%;
        font-size: 16px;
        text-align: center;
        position: relative;
    }

    .Navigation-fence-zid {
        position: absolute;
        width: 100%;
        margin-top: 0px;
        z-index: 999;
    }

    .Navigation-fence-zid dd {
        width: 100%;
        text-align: center;
        margin-top: -30px;
        border-radius: 2px;
        padding-bottom: 14px;
        overflow: hidden;
        line-height: 24px;
    }

    .Navigation-fence-zid .lied {
        border-top: 2px #0019a7 solid;
        width: 80%;
        margin: 0 auto;
    }

    .Navigation-fence-zid .dd {
        width: 100%;
        text-align: center;
        background: rgba(0, 25, 167, .5);
        overflow: hidden;
    }

    .Navigation-fence-zid dd span {
        width: 100%;
        display: block;
        color: #fff;
        position: relative;
        font-size: 14px;
         padding: 5px 0;
    }
    .Navigation-fence-zid dd a{
        color: #fff;
        display: block;
        width: 100%;
    }
    .Navigation-fence-zid dd span:hover a{
        color: #333;
    }
    .Navigation-cut {
    float: right;
    line-height: 104px;
    background-color: red;
    /* 针对不支持渐变的浏览器 */
    background-image: linear-gradient(to bottom right, #0084ff, #090252);
    height: 40px;
    width: 170px;
    border-radius: 50px;
    }

    .Navigation-cut p {
        float: left;
        line-height: 34px;
        width: 50%;
        text-align: center;
    }
    .Navigation-mane {
        width: 96%;
        margin: 0 auto;
        margin-top: 3px;
        background-color: #f2f2f2;
        height: 34px;
        border-radius: 50px;
    }
    .Navigation-mane-click {
        background-color: #fff;
        border-radius: 50px;
        box-shadow: -5px 0px 5px #d9d9d9;
    }
    .dd span:hover {
        background-color: #fff;
        color: #333;
    }
    .lans{
        color: #0019a7;
    }
    @media (max-width: 768px){
            .navBtn{
        animation: navBtnps 1s infinite ease;
        animation-iteration-count: 1;
         animation-fill-mode: forwards;
        }
        .navBtn{
            animation: navBtnps 1s infinite ease;
            animation-iteration-count: 1;
            animation-fill-mode: forwards;
        }
        .navBtn-fans{
            animation: navBtnps-fans 1s infinite ease;
            animation-iteration-count: 1;
            animation-fill-mode: forwards;
        }
        .leftBtf{
            animation: leftBtf 1s infinite ease;
            animation-iteration-count: 1;
            animation-fill-mode: forwards;
            display: block;
        }
        .leftBtf-fans{
            animation: leftBtf-fans 1s infinite ease;
            animation-iteration-count: 1;
            animation-fill-mode: forwards;
            display: block;
        }
        .sidq{
            width:39%;
            float: left;
            height: 100vh;
        }
        .Navigation-fence-zid{
            display: none;
        }
        .lastlist{
            display: block;
        }
        .Nav{
            height: 80px;
        }
        .Nav img{
            width: 90%;
        }
        .Navigation{
            position: fixed;
            z-index: 999;
            width: 100%;
            height: 100vh;
            top: 0;
            right: -60%;
            display: none;
 
        }
        .Navigation-nrk{
            width: 60%;
            float:right;
            background-color: #f3f3f3;
            height: 100vh;
            position: relative;
            overflow: hidden;
        }
        .nksid a{
            font-size: 14px;
            text-align: right;
        }
        .Navigation-fence-oen li{
            width: 90%;
            line-height: 60px;
            border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
            text-align: right;
            margin: 0 auto;
            float:none;
            line-height: 50px;
            position: relative;
            overflow: hidden;
        }
        .Navigation-fence-oen li .shoujk:before {
            content: '';
            border-left-width: 1px;
            border-left-style: solid;
            display: block;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 50px;
            border-color: rgba(0, 0, 0, 0.1);
        }
        .shoujk{
            float: left;
            width: 25%;
            height: 50px;
        }
        .nksid a{
            width: 70%;
            padding-right: 5%;
            display: block;
            float:right;
        }
        .Navigation-fence-oen .shoujk:after {
            content: '';
            border: 2px solid transparent;
            display: inline-block;
            width: 8px;
            height: 8px;
            margin: auto;
            position: absolute;
            top: 0;
            bottom: 0;
            -webkit-transform: rotate(-45deg);
            -moz-transform: rotate(-45deg);
            -ms-transform: rotate(-45deg);
            -o-transform: rotate(-45deg);
            transform: rotate(135deg);
            border-color: rgba(0, 0, 0, 0.3);
            border-top: none;
            border-left: none;
            left: 20px;
        }
        .Navigation-cut{        
            height: 34px;
            width: 230px;
        }
        .Navigation-cut p,.Navigation-mane{
            height: 28px;
        }
        .Navigation-cut p{
            line-height: 28px;
        }
        .flte{
            animation: mymove 0.5s infinite ease;
            animation-iteration-count: 1;
            animation-fill-mode: forwards;
            display: block;
        }
    }
</style>